import { render } from "./check-and-submit-condition.vue?vue&type=template&id=b48058aa"
import script from "./check-and-submit-condition.vue?vue&type=script&lang=ts"
export * from "./check-and-submit-condition.vue?vue&type=script&lang=ts"
script.render = render

export default script